import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from '@remix-run/react';
import { useEffect } from 'react';
import { initMixpanel } from './services/mixpanelService';

export default function App() {
  // Initialize Mixpanel on app load
  useEffect(() => {
    initMixpanel();
  }, []);

  const isProduction = process.env.NODE_ENV === 'production';
  const isStaging = process.env.NODE_ENV === 'staging';
  const showTawkTo = isProduction || isStaging; // Show in both production and staging

  return (
    <html>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width,initial-scale=1' />
        <link rel='preconnect' href='https://cdn.shopify.com/' />
        <link
          rel='stylesheet'
          href='https://cdn.shopify.com/static/fonts/inter/v4/styles.css'
        />
        <Meta />
        <Links />
        {showTawkTo && (
          <script
            dangerouslySetInnerHTML={{
              __html: `
                var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
                (function(){
                var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;
                s1.src='https://embed.tawk.to/68b5b5f38e5e8d7ad6a0139e/1j437jthh';
                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
                })();
              `,
            }}
          />
        )}
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
